import React from 'react';

import useScreen from '@lyearn/core/hooks/useScreen';
import { useTranslation } from '@lyearn/i18n';
import { Button, Loader, Popover, Typography } from '@lyearn/ui';
import { PopoverButtonProps } from '@lyearn/ui';

import LanguageSelector from './languageSelector';
import { EntityFilterProps } from './types';

const POPOVER_CLASSES: PopoverButtonProps['classes'] = {
  root: 'rounded-full justify-center items-center xs:h-32 xs:me-8',
};
const POPOVER_POSITION = 'bottom-start';

const EntityFilter: React.FC<React.PropsWithChildren<EntityFilterProps>> = (props) => {
  const { t } = useTranslation();
  const {
    open,
    onToggle,
    onChange,
    disableAddButton,
    isCreatingLocalizedContent,
    initialSelectedOptions,
  } = props;
  const { isMobile } = useScreen();

  return (
    <Popover open={open} onOpenChange={onToggle}>
      {({ open }) => (
        <>
          <Popover.Button classes={POPOVER_CLASSES} disabled={disableAddButton}>
            <Button variant="filled">
              {isCreatingLocalizedContent ? <Loader className="mr-12" /> : null}
              <Typography>Add languages</Typography>
            </Button>
          </Popover.Button>
          {open ? (
            <Popover.Content
              position={POPOVER_POSITION}
              renderAs={isMobile ? 'bottom-sheet' : 'popover'}>
              <LanguageSelector
                key={'loaded'}
                initialSelectedOptions={initialSelectedOptions}
                onChange={onChange}
                onToggle={onToggle}
              />
            </Popover.Content>
          ) : null}
        </>
      )}
    </Popover>
  );
};

export default EntityFilter;
